import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { CreateCouponDialogComponent } from './create-coupon-dialog/create-coupon-dialog.component';
import { CoupontblDataSource } from '../coupontbl/coupontbl-datasource';
import { DeleteCouponComponent } from './delete-coupon/delete-coupon.component';
import { DisableCouponComponent } from './disable-coupon/disable-coupon.component';
import { PushCouponComponent } from './push-coupon/push-coupon.component';
import { CouponService } from 'src/app/services/coupon.service';
import { tap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { projectConstants } from 'src/app/shared/constants/project-constants';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-coupon-list',
  templateUrl: './coupon-list.component.html',
  styleUrls: ['./coupon-list.component.css']
})
export class CouponListComponent implements OnInit , AfterViewInit {
  selectedIndex ;
  status = 'none';
  collapsed;
  coupon: any;
  dataSource =  new CoupontblDataSource(this.couponService);
  tableFilters = '';
  couponCount: number;
  screenHeight;
  screenWidth;
  small_device_display = false;
  @ViewChild('go', {static: false}) button: ElementRef;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['code', 'name', 'createdDate', 'validFrom', 'validTo',  'status'];

  constructor(private dialog: MatDialog, private couponService: CouponService, private commonFilter: CommonfilterService) { 
    this.onResize(); 
  }

  ngOnInit() {
    this.dataSource.loadCoupons(this.tableFilters, 'false', 0, 100);
    this.getTotalCountByFilters(this.tableFilters);
  }

  ngAfterViewInit() {

    this.paginator.page
    .pipe(
        tap(() => this.loadCouponsPage())
    )
    .subscribe();

    fromEvent(this.button.nativeElement, 'click')
    .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
            this.tableFilters = this.commonFilter.createfilterParams('coupon');
            this.getTotalCountByFilters(this.tableFilters);
            this.paginator.pageIndex = 0;
            this.loadCouponsPage();


        })
    )
    .subscribe();

}
onResize() {
  this.screenHeight = window.innerHeight;
  this.screenWidth = window.innerWidth;
  console.log(this.screenWidth);
  if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
    console.log(projectConstants.SMALL_DEVICE_BOUNDARY);
    console.log(this.screenWidth);
    this.small_device_display = true;
  } else {
    this.small_device_display = false;
  }
}
loadCouponsPage() {
  const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;

  this.dataSource.loadCoupons(

    this.tableFilters,
    'false',
    count,
    this.paginator.pageSize);
}

getTotalCountByFilters(filter) {
  this.couponService.getTotalFilterCount(filter)
  .subscribe( data => this.couponCount = data);
 }

  createCoupon() {
    const dialogreference = this.dialog.open(CreateCouponDialogComponent, {
      width: '900px',
      data: {'type': 'add'}
    });
    dialogreference.afterClosed().subscribe(result => {
      this.loadCouponsPage();
    });
  }

  deleteCoupon() {
    const dialogreference = this.dialog.open(DeleteCouponComponent, {
      width: '750px',
      data: this.selectedIndex
    });
    dialogreference.afterClosed().subscribe(result => {
      this.selectedIndex = -1;
      this.status = 'none';
      this.loadCouponsPage();
    });
  }
  disableCoupon() {
    const dialogreference = this.dialog.open(DisableCouponComponent, {
      width: '750px',
      data: this.selectedIndex
    });
    dialogreference.afterClosed().subscribe(result => {
      this.selectedIndex = -1;
      this.status = 'none';
      this.loadCouponsPage();
    });
  }
  pushCoupon() {
    const dialogreference = this.dialog.open(PushCouponComponent, {
      width: '750px',
      data: this.coupon
    });
    dialogreference.afterClosed().subscribe(result => {
      this.selectedIndex = -1;
      this.status = 'none';
      this.loadCouponsPage();
    });
  }
  updateCoupon() {
    const dialogRef = this.dialog.open(CreateCouponDialogComponent, {
      width: '800px',
      data: {'couponDetails': this.coupon, 'type': 'edit', 'status': this.coupon.couponStatus}
    });
    dialogRef.afterClosed().subscribe(response => {
      this.selectedIndex = -1;
      this.status = 'none';
      this.loadCouponsPage();
    });

  }
  onCouponCliked(coupon) {
    this.selectedIndex = coupon.jaldeeCouponCode;
    this.status = coupon.couponStatus;
    this.coupon = coupon;
  }

}
